var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"id":"logo","src":_vm.getLogo,"alt":"Logo"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$router.push({name: 'home'})}}})])}
var staticRenderFns = []

export { render, staticRenderFns }